import { RouteRecordRaw } from 'vue-router';

import { $i } from '@silae/composables';
// import { settingsLayoutComponents } from '~/pages/layout/layout';
import { RouteKeys } from '~/router/routes.domain';

export const MergeRoute: RouteRecordRaw = {
	name: RouteKeys.MERGE,
	path: 'merge',
	components: {
		default: () => import('./ui/pages/MergePage.vue')
	},
	meta: {
		label: 'merge.navigation',
		icon: () => $i('merge'),
		requiresAuth: true,
		isSettingsNavEntry: true,
		isSubEntry: false,
		order: 1
	}
};
